export const topBarInfo = {
  badge: "导读已更新",
  text: "新增「第三卷 · 分寸」分章概览与主题解析，本站文字版资源索引同步整理完成。",
  linkLabel: "直达阅读入口",
  linkHref: "#channels",
};

export const navLinks = [
  { label: "故事梗概", href: "#synopsis" },
  { label: "人物图谱", href: "#characters" },
  { label: "分章导读", href: "#chapters" },
  { label: "主题看点", href: "#themes" },
  { label: "阅读渠道", href: "#channels" },
  { label: "读者评价", href: "#reviews" },
  { label: "常见问题", href: "#faq" },
];

export const hero = {
  kicker: "伦理 · 婚恋 · 都市情感长篇",
  title: "我的朋友他的妻子",
  subtitle: "全文阅读与故事导览",
  intro:
    "一个关于友情、婚姻与选择的长篇故事。本站整理了它的故事梗概、人物关系、分章导读与文字版阅读入口，帮你在动手翻页之前，先看清这段关系为何一步步走到无法回头。",
  primaryCta: "从故事梗概开始",
  primaryHref: "#synopsis",
  secondaryCta: "查看文字版入口",
  secondaryHref: "#channels",
  coverAlt: "《我的朋友他的妻子》封面风格插画",
  bgAlt: "",
};

export const heroStats = [
  { value: "3", label: "分卷故事结构" },
  { value: "68+", label: "可浏览章节概览" },
  { value: "4", label: "条主题解析线" },
  { value: "10", label: "个阅读相关分区" },
];

export const synopsis = {
  title: "故事梗概",
  oneLine: "一句话概括：最近的朋友，往往也离你的婚姻最近。",
  lead:
    "《我的朋友他的妻子》属于网络连载中流传较广的伦理婚恋题材长篇，围绕一个普通的三人关系展开：叙述者「我」、他多年的好友，以及好友的妻子。故事从一次再平常不过的家庭聚会开始，用日常细节慢慢铺开三个人之间信任、分寸与欲望的拉扯。",
  paragraphs: [
    "故事并不急于抛出一个惊天动地的冲突，而是把重心放在日常里那些「本来没什么」的瞬间：一次临时的帮忙、一场没有主角的饭局、几句只有当事人听得懂的客套。正是这些细节一点点改变了三人的关系重量，也让读者不断自问，如果换作自己，会在哪一步停下。",
    "随着情节推进，友情、婚姻和自我认同三条线彼此缠绕。旧交情被反复提及，却在新处境里显得格外脆弱；婚姻表面安稳，底下却藏着未说出口的需求；而每一次选择都在给后续的走向增加不可逆的成本。故事用较为克制的叙述，让每个人都既是加害者，也是被环境推着走的人。",
    "需要说明的是，这部作品在网络上有多个流传版本，章节数量、结局走向与署名并不完全一致。本站整理的是各版本中较为共识的主线脉络，具体细节请以你实际阅读的版本为准。",
  ],
  highlights: [
    {
      title: "核心冲突",
      desc: "友情与婚姻的边界在哪里，以及当两者同时被触碰时，当事人要付出什么代价。",
    },
    {
      title: "叙事视角",
      desc: "以第一人称「我」为观察者，读者与叙述者信息同步，代入感强，也更容易被情绪牵着走。",
    },
    {
      title: "节奏特点",
      desc: "前段慢热、铺陈多，中段冲突密集，后段偏向人物内心的复盘与自省。",
    },
    {
      title: "题材标签",
      desc: "伦理、婚恋、都市、人妻、情感纠葛、群像，属于偏成人向的现实情感写作。",
    },
  ],
};

export const characters = {
  title: "人物图谱",
  desc: "故事人物不多，但每个人都承担着关系里不同的位置。理解他们各自动机所在，比记住名字更重要。",
  list: [
    {
      name: "「我」",
      role: "叙述者",
      tag: "旁观者 → 参与者",
      desc:
        "故事的视角人物，起初只是一个习惯性保持距离的旁观者，擅长把心事藏在客套里。随着关系变化，他被迫在忠诚与私心之间做出表态。",
      trait: "理性、克制、习惯性回避正面冲突",
    },
    {
      name: "朋友",
      role: "丈夫",
      tag: "被信任的人",
      desc:
        "「我」多年的好友，性格直接、重情义，把人与人的关系想得比较简单。他的信任是整个故事的前提，也是冲突升级后被反复考验的东西。",
      trait: "爽快、要面子、在亲密关系里略显迟钝",
    },
    {
      name: "他的妻子",
      role: "关键人物",
      tag: "关系的中心",
      desc:
        "故事矛盾的核心人物。她在婚姻里感到被忽视，却又不愿承认；她既渴望被理解，又清楚任何越界都意味着代价。她的每一个选择都在改写三个人的关系。",
      trait: "敏感、内敛、在体面与真心之间摇摆",
    },
    {
      name: "周围人",
      role: "群像",
      tag: "压力来源",
      desc:
        "亲友、同事与邻里构成了故事的背景噪音：闲话、善意提醒、若有若无的试探。他们不推动情节，却让「别人会怎么看」成为压在人物身上的一层重物。",
      trait: "并无恶意，却放大了当事人的犹豫",
    },
  ],
};

export const chapterGuide = {
  title: "分章导读",
  desc:
    "下面按分卷整理主线脉络。点击每一卷即可展开章节概览，方便你先判断节奏，再决定从哪一段读起。以下内容基于通行版本整理，仅供导读参考。",
  volumes: [
    {
      volume: "第一卷",
      title: "旧交情与新处境",
      summary:
        "介绍三位主角的日常关系，铺开友情与婚姻两条背景线，为后面的转折埋下大量细节伏笔。",
      chapters: [
        { n: "01", title: "周末的饭局", summary: "一次寻常的家庭聚餐，交代三人关系的亲疏与日常相处方式。" },
        { n: "02", title: "顺路的帮忙", summary: "一件本不值一提的小事，第一次让「分寸」这个词浮现出来。" },
        { n: "03", title: "旧照片", summary: "朋友翻出多年前的合影，友情的时间厚度被同时呈现与消耗。" },
        { n: "04", title: "没有主角的晚餐", summary: "朋友临时缺席，两个人的第一次独处，气氛安静得有些过分。" },
        { n: "05", title: "各自的沉默", summary: "第一巻收尾，三条线各自进入沉默期，读者能预感到松动。" },
      ],
    },
    {
      volume: "第二卷",
      title: "越界与自欺",
      summary:
        "冲突正式开始，人物开始在「只是朋友」的自我说服里越走越远，谎言与体面同时被放大。",
      chapters: [
        { n: "06", title: "借口变得熟练", summary: "联系的理由越来越自然，当事人却比谁都清楚哪里不对。" },
        { n: "07", title: "朋友的消息", summary: "丈夫一条再普通不过的问候，成为压在本就紧绷关系上的砝码。" },
        { n: "08", title: "雨天", summary: "被反复引用的关键场景，情绪在外部天气里找到出口。" },
        { n: "09", title: "第一次争吵", summary: "压抑后的爆发，却谁都没有把真正的问题说出口。" },
        { n: "10", title: "装作没事", summary: "表面和解，关系却已经回不到最初的重量。" },
        { n: "11", title: "第二卷收束", summary: "越界既成，人物开始为下一步找理由。" },
      ],
    },
    {
      volume: "第三卷",
      title: "分寸与代价",
      summary:
        "关系全面亮牌，三个人都要面对自己的选择，故事进入以内心复盘为主的后半程。",
      chapters: [
        { n: "12", title: "被看见", summary: "细节开始被人注意，外部压力正式介入。" },
        { n: "13", title: "摊牌之前", summary: "每个人都在为可能的后果做心理准备。" },
        { n: "14", title: "边界", summary: "故事标题所指的「分寸」被正面提出，也是全书的转折点。" },
        { n: "15", title: "代价", summary: "选择开始产生具体、不可撤销的后果。" },
        { n: "16", title: "之后", summary: "以偏冷静的笔调收尾，留下关于原谅与遗忘的开放讨论。" },
      ],
    },
  ],
};

export const themes = {
  title: "主题看点",
  desc: "同一个故事可以有很多种读法。切换下面的视角，看看这部作品最常被讨论的几条主题线。",
  tabs: [
    {
      id: "friendship",
      label: "友情与边界",
      headline: "当「朋友」变成一种责任，边界就开始模糊",
      points: [
        "故事反复强调旧交情的分量，正是这种分量让越界显得更难以承认。",
        "朋友之间的帮忙、托付与信任，在关系变质后全部变成了负担。",
        "作品没有简单地把任何一方写成反派，而是让「好意」本身成为隐患。",
      ],
      quote: "最伤人的往往不是恶意，而是所有人都觉得自己是一片好心。",
    },
    {
      id: "marriage",
      label: "婚姻与信任",
      headline: "表面安稳的婚姻，是如何一点点被忽视掏空的",
      points: [
        "婚姻中的沉默被写成一种慢性消耗，而非突然的背叛。",
        "信任一旦建立，就容易被当作理所当然，直到它被真正考验。",
        "故事追问：当一个人不再被看见时，责任该由谁来承担。",
      ],
      quote: "他们从不吵架，只是很久没有真正谈过话。",
    },
    {
      id: "desire",
      label: "欲望与克制",
      headline: "克制不是没有欲望，而是选择了代价",
      points: [
        "作品把「不说出口」当作一种主动选择，而不是道德的天然胜利。",
        "每一次克制都会留下痕迹，人物因此越来越疲惫。",
        "读者往往在人物的犹豫里看见自己的脆弱，这也是它被反复讨论的原因。",
      ],
      quote: "真正难的从来不是心动，而是心动之后还装作什么都没发生。",
    },
    {
      id: "choice",
      label: "选择与代价",
      headline: "没有完美的选项，只有你愿意承担的那一种",
      points: [
        "故事的高明之处，在于不给读者一个「正确答案」。",
        "每个选择都会关闭一些可能性，人物最终要为自己的决定负责。",
        "结局的开放性，让读者把问题带回自己的生活里继续思考。",
      ],
      quote: "后来他们都明白，有些路一旦走了第一步，就没有回头。",
    },
  ],
};

export const readingChannels = {
  title: "阅读渠道与文字版资源",
  desc:
    "这类网络长篇通常没有唯一官方入口。下面按资源类型整理了常见的查找方向，方便你按自己的习惯选择。点击标签可筛选。本站不承载正文，仅提供整理与索引。",
  filters: [
    { id: "all", label: "全部" },
    { id: "serial", label: "在线连载" },
    { id: "text", label: "文字版合集" },
    { id: "audio", label: "有声/听书" },
    { id: "community", label: "讨论社区" },
  ],
  list: [
    {
      type: "serial",
      name: "网络文学连载平台",
      format: "在线连载 · 逐章更新",
      desc: "部分读者记忆中的原始连载阵地，章节按顺序放出，评论区常能看到同期的追读讨论。",
      note: "适合：想按更新顺序慢慢读、习惯看章评的读者",
    },
    {
      type: "text",
      name: "文字版整理合集",
      format: "TXT / 分段长文",
      desc: "由读者自行整理的文字版本，通常把散落章节合并成完整长文，方便离线保存与打印。",
      note: "适合：想一次读完整本、或需要离线阅读的读者",
    },
    {
      type: "text",
      name: "读者自制分卷排版版",
      format: "分卷文档 · 带章节目录",
      desc: "在原文字版基础上重新分卷、校正错字并补齐目录的版本，阅读体验更接近正式出版物。",
      note: "适合：在意排版与错别字的读者",
    },
    {
      type: "audio",
      name: "有声播讲 / 听书平台",
      format: "音频 · 真人或 AI 播讲",
      desc: "不少听书平台收录了同题材的有声版本，播讲风格各异，适合通勤与睡前收听。",
      note: "适合：通勤路上或不方便看屏幕的读者",
    },
    {
      type: "community",
      name: "读者讨论帖与书评区",
      format: "论坛 / 社群讨论",
      desc: "围绕剧情走向、人物动机与结局解读的讨论帖，常见「各版本差异」的对照整理。",
      note: "适合：读完想找人聊聊、或想先看剧透再决定的读者",
    },
    {
      type: "community",
      name: "题材推荐榜单",
      format: "书单 / 合集推荐",
      desc: "同类伦理婚恋题材的推荐列表，常把本书与相近作品并列，方便一次找到多本可读内容。",
      note: "适合：读完意犹未尽、想找同类作品的读者",
    },
  ],
};

export const reviews = {
  title: "读者评价",
  desc: "以下评价整理自读者讨论中的常见观点，代表不同阅读偏好，不代表唯一结论。",
  list: [
    {
      name: "夜航船",
      meta: "读完通行版本 · 约三周",
      rating: 5,
      text:
        "前两卷的铺陈真的很慢，一度想弃，但撑过去之后会发现那些「没什么」的细节全是伏笔。第三卷讲分寸那段我反复看了好几遍。",
      tag: "重情节铺垫",
    },
    {
      name: "柠檬不加冰",
      meta: "听书版全文",
      rating: 4,
      text:
        "有声版本出人意料地合适，通勤路上听着听着就坐过站了。缺点是我听的那个版本结尾和前面对不上，后来才知道有好几个流传版本。",
      tag: "有声党",
    },
    {
      name: "北窗读书",
      meta: "对照过两个文字版",
      rating: 5,
      text:
        "建议先看梗概再决定读哪个版本，我第一遍读的结局偏仓促，换了整理版之后顺畅很多。人物动机也讲得更清楚。",
      tag: "版本党",
    },
    {
      name: "山间来信",
      meta: "读完 + 参与讨论帖",
      rating: 4,
      text:
        "题材本身不算新鲜，但它好在没有把任何人写成纯粹的坏人。看完之后跟朋友聊了一晚上，讨论点比剧情本身更有意思。",
      tag: "重主题",
    },
    {
      name: "周末翻页",
      meta: "在读 · 第二卷",
      rating: 4,
      text:
        "节奏偏慢，适合安静下来慢慢看。如果你想要快节奏反转可能会失望，但喜欢细腻心理描写的话会很对味。",
      tag: "慢阅读",
    },
    {
      name: "旧书店的猫",
      meta: "读完 + 追读完同类",
      rating: 5,
      text:
        "看完顺手在推荐榜单里找了几本同类。这本的强项是日常感，没有刻意煽情，越平静越让人心里发紧。",
      tag: "题材挖掘",
    },
  ],
};

export const readingTips = {
  title: "怎么读更顺畅",
  desc: "如果你第一次接触这类长篇，按下面的节奏进入会轻松很多。",
  steps: [
    {
      step: "01",
      title: "先看梗概，别怕剧透",
      desc: "这类故事重点不在「结果是什么」，而在「为什么走到这一步」。先知道主线反而更容易看懂细节。",
    },
    {
      step: "02",
      title: "确认你读的是哪个版本",
      desc: "网络流传版本差异不小，先看清章节数与结局，避免读到一半发现前后衔接不上。",
    },
    {
      step: "03",
      title: "慢读前两卷",
      desc: "前段铺陈密集，是主要伏笔区。第一遍不用急着推进，把人物关系记牢，后面会轻松很多。",
    },
    {
      step: "04",
      title: "读完再做一次主题回看",
      desc: "带着「友情、婚姻、欲望、选择」四条线回头翻一遍，会发现不少初读时忽略的呼应。",
    },
  ],
};

export const faq = {
  title: "常见问题",
  desc: "关于这部作品最常见的几个疑问，点击即可展开查看。",
  list: [
    {
      q: "《我的朋友他的妻子》一共有多少章、什么结局？",
      a: "没有统一答案。这部作品在网络上有多个流传版本，章节数量、卷次划分与结局走向并不完全一致，署名也常见差异。本站整理的是各版本中较为共识的主线脉络，具体请以你实际阅读的版本为准。",
    },
    {
      q: "哪里可以找到全文阅读？",
      a: "这类网络长篇通常没有唯一官方入口。你可以从在线连载平台、读者整理的文字版合集、有声平台和讨论社区几个方向寻找。本站「阅读渠道」分区按资源类型做了整理，方便你按习惯筛选。",
    },
    {
      q: "本站是否提供小说正文？",
      a: "不提供。本站只做故事梗概、人物、分章导读与资源方向的整理索引，正文请前往你选择的阅读渠道阅读。",
    },
    {
      q: "没读过这类题材，适合入门吗？",
      a: "题材偏成人向的现实情感写作，节奏偏慢、重心理描写。如果你习惯细腻的日常叙事，会比较对味；如果偏好快节奏强反转，可能会觉得前段偏闷，可以参照「怎么读更顺畅」的建议进入。",
    },
    {
      q: "各个版本差别大吗，会不会影响理解？",
      a: "主线人物与核心冲突基本一致，差别主要集中在章节切分、细节描写多寡和结局处理上。理解主线一般不受影响，但如果在意衔接完整度，建议一个版本读到底，不要中途混用。",
    },
  ],
};

export const relatedGenres = {
  title: "相关题材推荐",
  desc: "如果你喜欢这类作品，下面这些相邻题材方向通常也会合你的口味。",
  list: [
    {
      icon: "ri-heart-3-line",
      title: "婚恋现实向",
      desc: "聚焦长期关系中的疏离与修复，重日常细节与心理变化，节奏平稳。",
      tags: ["现实", "都市", "情感"],
    },
    {
      icon: "ri-group-line",
      title: "群像关系写实",
      desc: "以多人物视角展开，展现同一事件在不同立场下的不同解读。",
      tags: ["群像", "多视角"],
    },
    {
      icon: "ri-user-search-line",
      title: "伦理与抉择",
      desc: "围绕道德困境展开，重点不在对错，而在人物如何为自己的选择付出代价。",
      tags: ["伦理", "抉择"],
    },
    {
      icon: "ri-moon-clear-line",
      title: "慢节奏文学向",
      desc: "文字克制、情绪含蓄，适合安静环境下慢慢读的长篇。",
      tags: ["文学", "慢阅读"],
    },
  ],
};